
export const NoDataBox = ({ message = "No data found", className = "" }) => (
      <div className={`col-span-full  w-full h-full flex justify-center items-center text-lg text-gray-400 bg-opacity-50 font-medium py-10  border-2   bg-gray-50 ${className}`}>
          <p className="bg-gray-200 p-4">{message}</p>
   </div>
);
